module.exports = __webpack_public_path__ + "img/nav.a226d697.png";